import React from 'react'
import PropTypes from 'prop-types';

export const SkuLabelTicket = ({
    label,
    value
}:any) => {
    return (
        <div className="d-flex flex-row justify-content-between pl-4 pr-4">
             <span>{label}</span> <b>{value}</b>
        </div>
    )
}
SkuLabelTicket.propTypes = {
    label:PropTypes.string,
    value:PropTypes.string
}


